module.exports = __webpack_public_path__ + "img/flag-US.c7ef7aee.png";